import { useCallback, useState } from 'react'
import PropTypes from 'prop-types'

import ThankYou from './ThankYou'
import EmailForm from './EmailForm'
import { useTrackEmailCapture } from './events'

import classes from './EmailCapture.module.scss'

const EmailCapture = ({
  className = 'mc-theme-dark mc-bg-dark',
  trackProps,
  thankYouText,
  children,
  ...props
}) => {
  const [success, setSuccess] = useState(false)
  const onSubmit = useTrackEmailCapture(trackProps)

  const handleSubmit = useCallback(
    async (data) => {
      await onSubmit(data)
      setSuccess(true)
    },
    [onSubmit],
  )

  return (
    <section
      className='container mc-my-12 mc-pt-4 position-relative'
      data-testid='email-capture'
      id='email-capture'
    >
      <div className={className}>
        <div
          className={`position-absolute ${classes.thankYou} ${
            !success && classes.hidden
          }`}
        >
          <ThankYou descriptionText={thankYouText} />
        </div>
        <div className={success ? classes.hidden : ''}>
          <EmailForm onSubmit={handleSubmit} {...props}>
            {children}
          </EmailForm>
        </div>
      </div>
    </section>
  )
}

EmailCapture.propTypes = {
  className: PropTypes.string,
  trackProps: PropTypes.shape({
    campaign: PropTypes.string,
    category: PropTypes.string,
    contentType: PropTypes.string,
    location: PropTypes.string,
    slug: PropTypes.string,
  }),
  thankYouText: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.node),
  ]),
}

export default EmailCapture
